'use client';

import React__default from 'react';
import { TabCss } from '../styles/index.css.js';

function Tab(_a) {
    var label = _a.label, id = _a.id, onChangeTab = _a.onChangeTab, active = _a.active, disable = _a.disable;
    return (React__default.createElement(TabCss, { active: active, disable: disable, onClick: function () { return !disable && onChangeTab(id); } },
        React__default.createElement("span", null, label)));
}

export { Tab as default };
//# sourceMappingURL=Tab.js.map
